<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("documentvarification") }}
      </div>
      <div>
        <router-link class="btn-blue" to="document-verification"
          >{{ $t("documentvarification") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                v-model="documentDetails.vd_document_name"
                v-validate="'required'"
                placeholder="."
                type="text"
                name="vd_document_name"
                id="vd_document_name"
                v-b-tooltip.hover.top="$t(`Provide the name of the document`)"
              />
              <label>{{ $t("document") }} {{ $t("name") }}</label>
            </div>
            <!-- <Tooltip :title="`Provide the name of the document`" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('vd_document_name')">{{
              errors.first("vd_document_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected['to_verify'] && selected.to_verify.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $t("select") }} {{ $t("verificationtype") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.to_verify"
                variant="dropdown-curve"
                class="w-100"
                v-b-tooltip.hover.top="$t('Provide the method of verification')"
              >
                <b-dropdown-item
                  v-for="(to_verify, to_verifyIndex) in to_verification"
                  :key="to_verifyIndex"
                  v-on:click="onSelectHandler('to_verify', to_verify)"
                  name="selectto_verify"
                  id="selectto_verify"
                  >{{ to_verify }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="`Provide the method of verification`" /> -->
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  unchecked-value="N"
                  value="Y"
                  v-model="documentDetails.vd_is_active"
                  name="check-button"
                  switch
                  class="j-checkbox"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">
            {{ $t("save") }}
          </button>
          <!-- <button class="btn-blue">{{ $t('saveaddmore') }}</button>
          <button class="btn-black">{{ $t('reset') }}</button>-->
          <b-button
            @click.prevent.stop="onResetForm()"
            class="btn-outline-grey"
            variant="default"
            to="document-verification"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import moment from "moment";
import { METHODS } from "http";

export default {
  data() {
    return {
      submitted: false,
      to_verification: ["Address", "Age", "Organisation"],
      selected: {
        to_verify: "",
      },
      documentDetails: {
        vd_document_name: "",
        vd_document_verifies: "",
        vd_is_active: "",
        // cinema_name: ""
      },
    };
  },
  beforeMount() {
    const { vd_id } = this.$route.query;

    if (vd_id) {
      this.getdocumentDetails(vd_id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    getdocumentDetails: function (vd_id) {
      MasterService.getVerificationDocumentDetails({ vd_id }).then(
        (response) => {
          const { data } = response;
          // console.log("data :", data);
          if (data.Records) {
            this.documentDetails = {
              ...this.documentDetails,
              ...data.Records[0],
            };
          }
          this.onSelectHandler(
            "to_verify",
            this.documentDetails.vd_document_verifies
          );
        }
      );
    },
    onResetForm: function () {
      this.selected.to_verify = "";
      this.documentDetails = {
        vd_document_name: "",
        vd_document_verifies: "",
        vd_is_active: "",
      };
    },

    onSelectHandler: function (type, value) {
      if (type == "to_verify") {
        this.selected.to_verify = value;
        this.documentDetails.vd_document_verifies = value;
      }
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          MasterService.editVerificationDocument({ ...this.documentDetails })
            .then((response) => {
              const { data } = response;
              if (data.status) {
                this.$toasted.show(data.message);

                if (redirect) {
                  this.onResetForm(),
                    this.$router.push({
                      path: "/master/document-verification",
                    });
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/DocumentVerification/editDocumentVerification.vue